export const quotationObservations = {
  classValidation: (row: any) => {
    if (row.invalid) {
      return 'pending';
    }
    return '';
  },
  show: 'No hay datos que mostrar',
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  paginatorAllData: true,
  columns: [
    {
      title: 'Observaciones',
      name: 'observations',
      type: 'string',
      editable: false,
      class: 'center',
      value: (element: any) => element.observations
    }
  ]
}